<template>
  <div class="container-page-resumen">
    <div class="page-resumen--row">
      <div class="page-resumen--fotos">
        <img v-if="mapSatelliteImg !== ''" :src="mapSatelliteImg" alt="Mapa satelite">
        <exportvalmap
          v-if="mapSatelliteImg === ''"
          ref="exportvalmap"
          map-i-d="Asking_Var_YoY_Em2_resi"
          :legend-active="false"
          :geolevels="mapResumenPosition.geolevels"
          :latitude="mapResumenPosition.latitude"
          :longitude="mapResumenPosition.longitude"
          legendtitle="Titulo leyenda"
          basemap="satellite"
          :zoom="15"
          :opacity="0"
          @mapLoaded="getFotoMapa()"
        />
        <img v-if="mapSvImage !== null" :src="mapSvImage" alt="Google Street View">
      </div>
      <div class="page-resumen--map">
        <img :src="mapImg" :style="mapImgStyle" alt="">
      </div>
    </div>
    <div class="page-resumen--row">
      <div class="page-resumen--description">
        <div class="description--title">{{ $t("description") }}</div>
        <description v-model="data.description" :editable="false" />
      </div>
      <div class="page-resumen--table">
        <div class="valuation-table-container">
          <div class="valuation-table-container--table">
            <table aria-describedby="tabl1">
              <thead>
                <tr>
                  <th class="brains-strong--600 pb-1">{{ $t("district") }}</th>
                  <th class="brains-strong--600">{{ $t("marketplace.eur-sqm") }}</th>
                  <th class="brains-strong--600">€</th>
                  <th class="brains-strong--600">{{ $t("sqm") }}</th>
                  <th class="brains-strong--600">{{ $t("days") }}</th>
                </tr>
              </thead>
              <tbody class="table-color-secondary">
                <tr>
                  <td class="bt-secondary bl-secondary">{{ $t("asking-val") }}</td>
                  <td class="bt-secondary">
                    <span>{{ formatTableNum(data.priceSummary[0].pub_esqm) }}</span>
                  </td>
                  <td class="bt-secondary">
                    <span>{{ formatTableNum(data.priceSummary[0].pub_eur) }}</span>
                  </td>
                  <td class="bt-secondary">{{ formatTableNum(data.priceSummary[0].pub_sqm) }}</td>
                  <td class="bt-secondary br-secondary">{{ data.priceSummary[0].pubdays }}</td>
                </tr>
                <tr>
                  <td class="bl-secondary">{{ $t("closing-registery") }}</td>
                  <td>
                    <span>{{ formatTableNum(data.priceSummary[0].unpub_esqm) }}</span>
                  </td>
                  <td>
                    <span>{{ formatTableNum(data.priceSummary[0].unpub_eur) }}</span>
                  </td>
                  <td>{{ formatTableNum(data.priceSummary[0].unpub_sqm) }}</td>
                  <td class="br-secondary">{{ data.priceSummary[0].unpubdays }}</td>
                </tr>
                <tr class="brains-table-tr-grey">
                  <td class="bl-secondary bb-secondary">{{ $t("valuationFilters.discount") }}</td>
                  <td class="bb-secondary">
                    <span>{{ formatTableNum(data.priceSummary[0].discount_esqm) }}%</span>
                  </td>
                  <td class="bb-secondary">
                    <span>{{ formatTableNum(data.priceSummary[0].discount_eur) }}%</span>
                  </td>
                  <td class="bb-secondary" />
                  <td class="bb-secondary br-secondary" />
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="valuation-table-container second-table">
          <div class="valuation-table-container--table">
            <table aria-describedby="table2">
              <thead>
                <tr>
                  <th class="brains-strong--600">{{ $t("comps-val") }}</th>
                  <th class="brains-strong--600">{{ $t("marketplace.eur-sqm") }}</th>
                  <th class="brains-strong--600">€</th>
                  <th class="brains-strong--600">{{ $t("sqm") }}</th>
                  <th class="brains-strong--600">{{ $t("days") }}</th>
                </tr>
              </thead>
              <tbody class="table-color-primary">
                <!-- First elements -->
                <tr class="table-tr-published">
                  <td class="bt-primary bl-primary">{{ $t("valuationFilters.published") }}</td>
                  <td class="bt-primary">{{ formatTableNum(data.priceSummary[1].pub_esqm) }}</td>
                  <td class="bt-primary">{{ formatTableNum(data.priceSummary[1].pub_eur) }}</td>
                  <td class="bt-primary">{{ formatTableNum(data.priceSummary[1].pub_sqm) }}</td>
                  <td class="bt-primary br-primary">{{ formatTableNum(data.priceSummary[1].pubdays) }}</td>
                </tr>
                <tr class="table-tr-unpublished">
                  <td class="bl-primary">{{ $t("valuationFilters.unpublished") }}</td>
                  <td>{{ formatTableNum(data.priceSummary[1].unpub_esqm) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[1].unpub_eur) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[1].unpub_sqm) }}</td>
                  <td class="br-primary">{{ formatTableNum(data.priceSummary[1].unpubdays) }}</td>
                </tr>
                <tr class="brains-table-tr-grey">
                  <td class="bl-primary">{{ $t("valuationFilters.discount") }}</td>
                  <td>{{ formatTableNum(data.priceSummary[1].discount_esqm) }}%</td>
                  <td>{{ formatTableNum(data.priceSummary[1].discount_eur) }}%</td>
                  <td />
                  <td class="br-primary" />
                </tr>
                <!-- Second elements -->
                <tr class="table-tr-sel-published">
                  <td class="bl-primary">{{ $t("selected-published") }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].pub_esqm) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].pub_eur) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].pub_sqm) }}</td>
                  <td class="br-primary">{{ formatTableNum(data.priceSummary[2].pubdays) }}</td>
                </tr>
                <tr class="table-tr-sel-unpublished">
                  <td class="bl-primary">{{ $t("selected-unpublished") }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].unpub_esqm) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].unpub_eur) }}</td>
                  <td>{{ formatTableNum(data.priceSummary[2].unpub_sqm) }}</td>
                  <td class="br-primary">{{ formatTableNum(data.priceSummary[2].unpubdays) }}</td>
                </tr>
                <tr class="brains-table-tr-grey">
                  <td class="bl-primary bb-primary">{{ $t("valuationFilters.discount") }}</td>
                  <td class="bb-primary">{{ formatTableNum(data.priceSummary[2].discount_esqm) }}%</td>
                  <td class="bb-primary">{{ formatTableNum(data.priceSummary[2].discount_eur) }}%</td>
                  <td class="bb-primary" />
                  <td class="bb-primary br-primary" />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import description from '@/components/designComponents/description'
import exportvalmap from './exportvalmap.vue'
import { getGoogleStreetViewImage } from '@/api/comparables'

export default {
  name: 'PageResumen',
  components: { exportvalmap, description },
  props: {
    data: {
      default: null
    },
    mapImg: {
      default: null
    },
    mapResumenPosition: {
      default: null
    }
  },
  data() {
    return {
      description_build: '<span class="font-weight-600" style="font-size: 18px;">The asset</span> <br /><br /> <p>The asset is located in...</p>',
      mapSatelliteImg: '',
      mapSvImage: null,
      mapImgWidthStyle: null,
      mapImgHeightStyle: null,
      mapImgStyle: null
    }
  },
  computed: {},
  watch: {
    mapSvImage(newOne, oldOne) {
      this.$emit('imageSV', newOne)
    },
    mapSatelliteImg(newOne, oldOne) {
      this.$emit('imageSatellite', newOne)
    }
  },
  mounted: function() {
    setTimeout(() => {
      this.getFotoMapa()
    }, 5000)
    setTimeout(() => {
      this.setMapImgData()
    }, 500)
    this.loadSVImage()
  },
  methods: {
    // Se posiciona la imagen de tal forma que no se descoloque en otras resoluciones
    setMapImgData() {
      this.mapImgWidthStyle = document.querySelector('.page-resumen--map img').clientWidth / 2
      this.mapImgHeightStyle = document.querySelector('.page-resumen--map img').clientHeight / 2
      this.mapImgStyle = 'left: calc(50% - ' + this.mapImgWidthStyle + 'px); top: calc(50% - ' + this.mapImgHeightStyle + 'px)'
    },
    loadSVImage() {
      const vm = this
      var filter = {
        latitude: vm.mapResumenPosition.latitude,
        longitude: vm.mapResumenPosition.longitude,
        heading: 270,
        zoom: 1,
        pitch: 0
      }

      if (vm.data.streetViewOrientation !== null) {
        filter.latitude = vm.data.streetViewOrientation.lat
        filter.longitude = vm.data.streetViewOrientation.lng
        filter.heading = vm.data.streetViewOrientation.pov.heading
        filter.zoom = vm.data.streetViewOrientation.pov.zoom
        filter.pitch = vm.data.streetViewOrientation.pov.pitch
      }

      getGoogleStreetViewImage(filter).then((res) => {
        var reader = new FileReader()
        reader.readAsDataURL(res.data)
        reader.onloadend = function() {
          vm.mapSvImage = reader.result
        }
      })
    },
    formatDecimalValue(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatTableNum(num) {
      if (num !== undefined) {
        return num.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      } else {
        return num
      }
    },
    getFotoMapa() {
      this.$refs.exportvalmap.currentMapView.takeScreenshot().then(async(screenshot) => {
        this.mapSatelliteImg = screenshot.dataUrl
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page-resumen {
  width: 100%;
  height: 100%;
  display: grid;

  grid-template-columns: 1fr;
  grid-template-rows: 55% 45%;
  gap: 20px;

  .page-resumen--row {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 20px;
    justify-content: space-between;

    .page-resumen--fotos {
      display: flex;
      justify-content: space-between;
      width: 100%;

      img {
        width: 48%;
      }

      div {
        width: 48%;
      }
    }

    .page-resumen--map {
      overflow: hidden;
      position: relative;

      img {
        // background-position: center;
        // width: 100%;
        // height: 100%;

        position: absolute;
        // top: -250px;
        // left: -140px;
        // top: -220px;
        // left: -35%;
        // left: calc(50% - 527px);
        // top: calc(50% - 437px);
      }
    }

    .page-resumen--description {
      .description--title {
        margin-bottom: 10px;
        font-family: "Montserrat-SemiBold",sans-serif;
      }
    }
  }
}

.valuation-table-container--table {
  font-family: "Montserrat-Regular",sans-serif;
  font-size: 14px;

  table {
    thead {
      tr th {
        padding-bottom: 5px;
      }
    }

    .table-color-primary {
      border: 2px solid #1e3cff;
    }

    .table-color-secondary {
      border: 2px solid #009999;
    }

    tbody {
      margin-top: 5px;

      .brains-table-tr-grey {
        color: grey;

        td:nth-child(1) {
          padding-left: 15px;
        }
      }

      tr {
        td {
          padding: 3px;
          border: 1px solid white;
          font-size: 13px;
        }

        td:nth-child(1) {
          background-color: white;
        }
      }

      .table-tr-published {
        background-color: rgb(232, 210, 128);
      }

      .table-tr-unpublished {
        background-color: rgb(240, 240, 240);
      }

      .table-tr-sel-published {
        background-color: rgb(216, 175, 70);
      }

      .table-tr-sel-unpublished {
        background-color: rgb(194, 194, 194);
      }
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th:nth-child(1) {
      width: 35%;
      text-align: left;
    }
    th:nth-child(2) {
      width: 18%;
      text-align: center;
    }
    th:nth-child(3) {
      width: 18%;
      text-align: center;
    }
    th:nth-child(4) {
      width: 18%;
      text-align: center;
    }
    th:nth-child(5) {
      width: 11%;
      text-align: center;
    }

    td:nth-child(1) {
      width: 35%;
      text-align: left;
    }
    td:nth-child(2) {
      width: 18%;
      text-align: center;
    }
    td:nth-child(3) {
      width: 18%;
      text-align: center;
    }
    td:nth-child(4) {
      width: 18%;
      text-align: center;
    }
    td:nth-child(5) {
      width: 11%;
      text-align: center;
    }
  }
}

.second-table {
  margin-top: 12px;
}

.brains-description-container {
  height: 250px;
}
</style>
